module.exports = ".overlay { background-color:rgba(0,0,0,0.1) !important; -webkit-transition:all .4s ease-in-out; transition:all .4s ease-in-out;}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/training-and-products/training-and-products.component.css
// module id = ./src/app/shared/training-and-products/training-and-products.component.css
// module chunks = main